export default {
  instagram: /instagram.com\/([\w\.]+)/,
  youtube: /youtube\.com\/(?:channel\/|ch\/|c\/|user\/|@)?([\w-]+)/,
  tiktok: /tiktok.com\/@([\w\.]+)/,
  snapchat: /snapchat.com\/add\/([\w\.]+)/,
  linkedin: /linkedin.com\/in\/([\w\.]+)/,
  web: /(?:www\.)?([\w-]+\.[a-zA-Z]{2,})/
}
